import LoadingSpinner from "@/components/LoadingSpinner";
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { loginApi } from "@/utils/apis/auth-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useRegistrationStore } from "@/utils/stores/useRegistrationStore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RegistrationSuccess = () => {

    const { sendEvent } = useCreateEvent()
    const navigate = useNavigate();
    const { login } = useAuthStore();
    const { registrationData, clearRegistrationData } = useRegistrationStore()
    const email = registrationData.registrationEmail
    const password = registrationData.password

    const callLogin = async (email: string, password: string) => {
        try {
            const result = await loginApi(email, password)
            if (result.idToken && result.accessToken && result.userId && result.refreshToken && result.expiryTime) {
                await sendEvent({
                    event: EventType.LOGIN_SUCCESS,
                    user_id: result.userId,
                });
                login(result.idToken, result.userId, result.accessToken, result.refreshToken, result.expiryTime);
                navigate("/fetch-user-data");
            } else {
                throw new Error("Missing token or user information in the response.");
            }
        } catch (error) {
            if (error instanceof Error) {
                await sendEvent({
                    event: EventType.LOGIN_FAILED,
                    sub_category: "exception",
                    event_metadata: { email, message: error.message }
                });
                navigate("/login")
            } else {
                console.error("Unexpected error type:", error);
            }
        } finally {
            clearRegistrationData()
        }
    }

    useEffect(() => {
        if (!email || !password) return
        callLogin(email, password)
    }, [])

    // ********************************************************************************

    return (
        <div className="w-full h-screen flex flex-col items-center background-logo">
            <div className="w-[90%] h-full md:w-[392px] flex items-center justify-center">
                <div className="w-full py-[20px] bg-white flex flex-col items-center space-y-[20px]">
                    <div className="font-bold text-[30px] leading-[38px] text-center">
                        Account creato correttamente
                    </div>
                    <div className="font-normal text-[18px] leading-[26px] text-center">
                        Stai per essere reindirizzato alla tua Area Personale
                    </div>
                    <LoadingSpinner />
                </div>
            </div>
        </div>
    )
}

export default RegistrationSuccess
